import {RestClient} from "zavadil-ts-common";
import {ScraperStatusPayload} from "../../types/Scraper";
import {GenericResponsePayload} from "../../types/GenericResponsePayload";

export class ScraperClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	status(): Promise<ScraperStatusPayload> {
		return this.client.getJson('scraper/status');
	}

	stop(): Promise<GenericResponsePayload> {
		return this.client.getJson('scraper/stop');
	}

	scrapeAll(): Promise<GenericResponsePayload> {
		return this.client.getJson('scraper/scrape/all');
	}

	scrapeLookups(): Promise<GenericResponsePayload> {
		return this.client.getJson('scraper/scrape/lookups');
	}

	scrapeContacts(sourceId?: string): Promise<GenericResponsePayload> {
		return this.client.getJson('scraper/scrape/contacts', {sourceId});
	}

}
